import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { BookActivityForm } from "../BookActivityForm";
import { EditBookActivityModalProps } from "./types";
import { useEditBookActivityModal } from "./controller";

export const EditBookActivityModal = React.memo(({ modalRef, onComplete }: EditBookActivityModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditBookActivityModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_activity_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <BookActivityForm />
    </Modal>
  );
});
